import type { CSSProperties } from "react"

export const colorTagStyle = (colorValue: string): CSSProperties => ({ color: colorValue })
